class RodFlowResults extends React.Component {
  constructor(props) {
    super(props);
    var newState = {
      currentStep: 1,
      stepValues: {
        1: null,
        2: null,
        3: null
      }
    };
    if (typeof props.init != 'undefined') {
      newState = props.init(newState);
    }
    this.state = newState;
  }
  render() {
    const steps = this.props.content;
    const stepValues = this.state.stepValues;

    var fields = Object.keys(steps).map(function (key, index) {
      let fieldval = '(Not Set)';
      if (typeof stepValues[key] != undefined) {
        for (var i in steps[key].options) {
          if (steps[key].options[i].value == stepValues[key]) {
            fieldval = steps[key].options[i].text;
          }
        }
      }
      let field = React.createElement(
        'div',
        { className: 'row', key: key },
        React.createElement(
          'div',
          { className: 'col-sm-6' },
          React.createElement(
            'div',
            { className: 'lbltxt' },
            steps[key].stepText,
            ':'
          ),
          React.createElement('input', { className: 'txtbox', type: 'text', value: fieldval, disabled: true }),
          React.createElement('input', { type: 'hidden', name: "contact[" + steps[key].stepText + "]", value: fieldval, readonly: true })
        )
      );
      return field;
    }, this);

    return React.createElement(
      'div',
      { className: 'results-fields' },
      fields
    );
  }
}

// window.RodFlowResults = React.render(
//   <RodFlow content={FlowContent} />,
//   document.getElementById('rodflow-root')
// );
